import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Form } from 'react-bootstrap';
import { Button } from "@app/components";
import { toast } from 'react-toastify';
import { createSchoolService, getAllGrades, getAllSchools } from '@app/services/school';
import { useDispatch, useSelector } from 'react-redux';
import CreatableSelect from 'react-select/creatable';
import moment from 'moment';
import { Link } from 'react-router-dom';

const gender = [
    {id:'male',name:'Male'},
    {id:'female','name':'Female'},
    {id:'other','name':'Rather Not Specify'}
];

const EnrollmentStep1 = (props) => {
        
    const enrollmentStore = useSelector((state: any) => state.enrollmentForm);
    const [grades, setGrades] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const dispatch = useDispatch();
    
    useEffect(() => {
        getAllActiveSchools()
        getGrades()
        
        return () => {

        }
    },[]);

    const getGrades = async () => {
        try{
            const resp = await getAllGrades();
            if (resp.success === true) {
                setGrades(resp.collections);
            } else {
                toast.error(resp?.errors[0]?.msg);
            }
        }catch (error: any){
            toast.error(error?.message || 'Internal Server Error');
        }
    }

    const createOption = (label:string, id) => ({ label, value:id });
    
    let defaultSchoolOptions = [];
    const [schoolOptions, setSchoolOptions] = useState(defaultSchoolOptions);

    // TODO: New school creation temporarily disabled
    // const handleCreateOptions = (inputValue: string) => {
    //     setLoading(true);
    //     const postData = {name:inputValue};
    //     setTimeout(() => {
    //         setLoading(false);
    //         createSchool(postData);
    //     }, 1000);
    // };

    // const createSchool = async (payload) => {
    //     try{
    //         const resp = await createSchoolService(payload);
    //         if (resp.success === true) {
    //             console.log(resp)
    //             if(resp.collections.length > 0){
    //                 resp.collections.map((school)=>{
    //                     const newOption = createOption(school.name,school.id);
    //                     setSchoolOptions([...schoolOptions, newOption]);
    //                     setFieldValue('school_id',school.id);
    //                 })
    //             }
    //         } else {
    //             toast.error(resp?.errors[0]?.msg);
    //         }
    //     }catch(error : any){
    //         toast.error(error?.message || 'Internal Server Error');
    //     }
    // }

    const getAllActiveSchools = async () => {
        try{
            const resp = await getAllSchools();
            if (resp.success === true) {
                resp.collections.map((obj)=>{
                    defaultSchoolOptions.push(createOption(obj.name, obj.id));
                });
                setSchoolOptions(defaultSchoolOptions);
            } else {
                toast.error(resp?.errors[0]?.msg);
            }
        }catch (error: any){
            toast.error(error?.message || 'Internal Server Error');
        }
    }
    
    const { handleChange, values, handleSubmit, touched, errors, setFieldValue } = useFormik({
        initialValues: {
            step: 1,
            first_name: enrollmentStore?.formData?.first_name || '',
            last_name: enrollmentStore?.formData?.last_name || '',
            date_of_birth: moment(enrollmentStore?.formData?.date_of_birth).format('YYYY-MM-DD') || '',
            gender: enrollmentStore?.formData?.gender || '',
            school_id: enrollmentStore?.formData?.school_id || '',
            grade_id: enrollmentStore?.formData?.grade_id || '',
        },
        validationSchema: Yup.object({
            first_name: Yup.string().trim().required('Please enter first name'),
            last_name: Yup.string().trim().required('Please enter last name'),
            date_of_birth: Yup.string().trim().required('Please enter date of birth'),
            gender: Yup.string().required('Please select gender'),
            // school_id: Yup.string().required('Please enter school name'),
            grade_id: Yup.string().required('Please select year group'),
        }),
        onSubmit: (values) => {
            props?.updateEnrollmentDetailsAPI(values)
        },
        enableReinitialize: true,
    });

    return (
        <>
        <Form onSubmit={handleSubmit}>
        <div className="content mb-3">
            <h6 className="mb-4 grey_wrapper_title"><i className="fas fa-user-graduate"/> &nbsp; Student Details </h6>
            <div className="content_inner_wrap">
                <div className="row">
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor="exampleInputEmail1">First Name <span className="required">*</span></label>
                            <input type="text" className="form-control" id="exampleInputEmail1" placeholder="Enter first name" 
                                name="first_name" 
                                onChange={handleChange} 
                                value={values.first_name}
                            />
                            {(touched.first_name && errors.first_name) && (
                                <div className="text-danger">
                                    {errors.first_name}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor="exampleInputEmail1">Last Name <span className="required">*</span></label>
                            <input type="text" className="form-control" id="exampleInputEmail1" placeholder="Enter last name" 
                                name="last_name" 
                                onChange={handleChange} 
                                value={values.last_name}
                            />
                            {(touched.last_name && errors.last_name) && (
                                <div className="text-danger">
                                    {errors.last_name}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor="exampleInputEmail1">Date Of Birth <span className="required">*</span></label>
                            <Form.Control 
                                type="date" 
                                name="date_of_birth" 
                                id="date_of_birth" 
                                placeholder="Enter date of birth" 
                                value={values.date_of_birth}
                                onChange={handleChange}
                            />
                            {(touched.date_of_birth && errors.date_of_birth) && (
                                <div className="text-danger">
                                    {errors.date_of_birth}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor="exampleInputGender">Gender <span className="required">*</span></label>
                            <select
                                className="form-control"
                                name="gender"
                                onChange={handleChange} 
                                value={values.gender}
                            >
                                <option value="">--Please select--</option>
                                {gender.map((obj) => (
                                    <option key={obj.id} value={obj.id}>
                                        {obj.name}
                                    </option>
                                ))}
                            </select>
                            {(touched.gender && errors.gender) && (
                                <div className="text-danger">
                                    {errors.gender}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor="exampleInputEmail1">School Name </label>
                            <CreatableSelect
                                isClearable
                                isDisabled={isLoading}
                                isLoading={isLoading}
                                onChange={ (option) => { 
                                    if(option){
                                        setFieldValue("school_id", option.value)
                                    }else{
                                        setFieldValue("school_id", '')
                                    }
                                }}
                                // onCreateOption={handleCreateOptions} // TODO: re-enable when new school creation is needed
                                isValidNewOption={() => false} // TODO: Comment when new school creation is needed
                                options={schoolOptions}
                                value={schoolOptions.filter(function(option) {
                                    return option.value === values.school_id;
                                })}
                                name="school_id"
                            />
                            {(touched.school_id && errors.school_id) && (
                                <div className="text-danger">
                                    {errors.school_id}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor="exampleInputGrade">Year Group <span className="required">*</span></label>
                            <select
                                className="form-control"
                                name="grade_id"
                                onChange={handleChange} 
                                value={values.grade_id}
                            >
                                <option value="">--Please select--</option>
                                {grades.map((obj) => (
                                        <option key={obj.id} value={obj.id}>
                                            {obj.name}
                                        </option>
                                ))}
                            </select>
                            {(touched.grade_id && errors.grade_id) && (
                                <div className="text-danger">
                                    {errors.grade_id}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <label htmlFor="exampleInputGrade">Subject(s) Enrolled <span className="required">*</span></label>
                        { enrollmentStore?.formData?.subjects && enrollmentStore?.formData?.subjects.map((obj, i) => ( 
                            <div className="icheck-primary" key={i}>
                                <input 
                                    type="checkbox" 
                                    className="form-check-input" 
                                    checked
                                    id="subject-1"
                                    name="subject-1"
                                    // onChange={ handleChange }
                                    readOnly
                                />
                                <label htmlFor="subject-1" className="form-check-label">
                                    <b>{ obj?.subject_name }</b>
                                </label>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
        <div className="mx-4 d-flex justify-content-between align-items-center">
            <Link className="btn btn-default float-right" to="/" > Back To Dashboard </Link>
            <Button type="submit" isLoading={isLoading} className="btn btn-primary"> Next </Button>
        </div>
        </Form>
        </>
  );
};

export default EnrollmentStep1;